import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {AbstractCreateModalComponent} from '../abstract-create-modal';
import {ResidentForSelect} from '../../../../types/data.types';

declare const toastr: any;

@Component({
    selector: 'parking-spot-create',
    templateUrl: './parking-spot-create.component.html'
})
export class ParkingSpotCreateComponent extends AbstractCreateModalComponent implements OnInit {
    rentedToSuites = [];
    residents = [];
    title = 'Parking Spot';
    buildingSelectIsDisabled = false;

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService
    ) {
        super(directoryService, api);
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            toastr.warning('Send data not valid.');
            if (!form.value.building)      toastr.warning('Building should not be blank.');
            if (!form.value.suite)         toastr.warning('Unit should not be blank.');
            if (!form.value.parkingNumber) toastr.warning('Parking Spot should not be blank.');

            return;
        }
        let data: any = {
            building:         form.value.building,
            suite:            form.value.suite,
            parkingNumber:    form.value.parkingNumber,
            legalDescription: form.value.legalDescription,
            level:            form.value.level,
            rentedOut:        form.value.rentedOut,
            rentedTo:         form.value.rentedTo,
            garageRemote:     form.value.garageRemote,
            handicap:         form.value.handicap,
            note:             form.value.note,
        };

        const suite = this.rentedToSuites.find(s => s.id == form.value.rentedToSuite);
        const resident = this.residents.find(s => s.id == form.value.suiteUser);
        if(form.value.rentedOut) {
            data.extendedRentedTo = {
                building:  form.value.rentedToBuilding ? form.value.rentedToBuilding : undefined,
                suite:     form.value.rentedToSuite ? form.value.rentedToSuite : undefined,
                suiteNumber: form.value.rentedToSuite && suite ? suite.suiteNumber : form.value.suiteNumber,
                suiteUser: form.value.suiteUser && form.value.suiteUser != '0' ? form.value.suiteUser : undefined,
                suiteUserName: form.value.suiteUser && resident ? resident.fullName : form.value.suiteUserName,
            };
        }

        this.directoryService.currentTabId = 'parking-spots';
        this.create(data);
    }

    changeBuilding(buildingId: string, form) {
        form.controls['rentedToSuite'].reset();
        form.controls['suiteUser'].reset();
        this.getRentedToSuites(+buildingId, null, form);
    }

    getRentedToSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.rentedToSuites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.rentedToSuites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.rentedToSuites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        // if(form.controls['suiteUser'].value !== 0)
        form.controls['suiteUser'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['suiteUser'].setValue(0);
            setTimeout(() => {
                form.controls['suiteNumber'].reset();
                form.controls['suiteUserName'].reset();
                // this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    rentedToSuiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) {
            this.residents = [new ResidentForSelect(0, 'Other')];
            return;
        }
        const url = `/v1/suite-users/g_emshort.json?expand=user&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.rentedToSuite !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.user.fullName, [], item.user.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    changeResident(residentId: number) {
        if (!+residentId)
            this.form.value.suiteUserName = '';
    }
}






// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/parking-spot-create/parking-spot-create.component.ts